import { Plus, X } from 'lucide-react';

export default function FaseEditor({ titulo, items, onUpdate, onAdd, onRemove }) {
  return (
    <div className="mt-3 p-3 bg-black/20 rounded border border-neutral-900">
      <div className="flex items-center justify-between mb-2">
        <div className="text-xs font-semibold text-white">{titulo}</div>
        <button
          onClick={onAdd}
          className="text-[10px] text-brand-gold hover:text-yellow-400 flex items-center gap-1"
        >
          <Plus className="w-3 h-3" /> Agregar
        </button>
      </div>
      <div className="space-y-1.5">
        {items.map((item, idx) => (
          <div key={idx} className="flex items-center gap-2">
            <input
              type="text"
              value={item.label}
              onChange={(e) => onUpdate(idx, 'label', e.target.value)}
              className="flex-1 px-2 py-1.5 bg-neutral-900 border border-neutral-800 rounded text-xs text-white focus:outline-none focus:border-brand-gold/50"
            />
            <input
              type="number"
              value={item.precio}
              onChange={(e) => onUpdate(idx, 'precio', parseFloat(e.target.value) || 0)}
              className="w-28 px-2 py-1.5 bg-neutral-900 border border-neutral-800 rounded text-xs text-white text-right focus:outline-none focus:border-brand-gold/50"
            />
            <button
              onClick={() => onRemove(idx)}
              className="text-neutral-600 hover:text-red-400 p-1"
            >
              <X className="w-3 h-3" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
